/* Mobile sticky ATC hand-off -- Sep 22 2026. See assets/mw-sticky-atc.css for the why.
   Toggles .mw-atc-inline on the PDP's .payment-buttons: inline while its normal
   spot is fully on screen, fixed bottom bar (the existing pdp-redesign.css rule)
   the rest of the time. Mobile only; desktop is never touched. */
(function () {
  var mq = window.matchMedia('(max-width: 768px)');
  var root = document.documentElement;

  // While the Pandectes cookie banner is open it covers the in-page buttons,
  // so keep the bar (the CSS lifts the banner above it) until it is answered.
  function cookieBannerOpen() {
    var b = document.querySelector('.pd-cookie-banner-window');
    if (!b || !b.getBoundingClientRect().height) return false;
    var cs = getComputedStyle(b);
    return cs.visibility !== 'hidden' && cs.opacity !== '0';
  }

  function setup(pay) {
    if (pay.getAttribute('data-mw-atc')) return;
    if (pay.closest('.modal--quick-shop')) return;
    pay.setAttribute('data-mw-atc', '1');

    var slot = document.createElement('div');
    slot.className = 'mw-atc-slot';
    slot.setAttribute('aria-hidden', 'true');
    pay.parentNode.insertBefore(slot, pay);

    var inFlowHeight = 0;
    var inline = false;
    var queued = false;
    var seenInline = false;
    var nudged = false;

    function syncBarFlag() {
      var barOn = mq.matches && !inline;
      root.classList.toggle('mw-atc-bar-on', barOn);
      if (barOn) root.style.setProperty('--mw-atc-bar-h', pay.offsetHeight + 'px');
    }

    function apply(nextInline) {
      inline = nextInline;
      pay.classList.toggle('mw-atc-inline', inline);
      slot.style.height = inline ? '0px' : inFlowHeight + 'px';
      syncBarFlag();
    }

    // Slide the bar in; the first time it comes back after the shopper has
    // seen the in-page buttons, also pulse Add to cart so they notice it.
    function animateBarIn() {
      pay.classList.remove('mw-atc-enter');
      void pay.offsetWidth;
      pay.classList.add('mw-atc-enter');
      if (seenInline && !nudged) {
        nudged = true;
        pay.classList.add('mw-atc-nudge');
      }
    }

    pay.addEventListener('animationend', function (e) {
      if (e.target === pay) pay.classList.remove('mw-atc-enter');
      else if (e.animationName === 'mw-atc-pulse') pay.classList.remove('mw-atc-nudge');
    });

    // Height (incl. top margin) the buttons take when they sit in the page.
    function measure() {
      if (!mq.matches) {
        pay.classList.remove('mw-atc-inline');
        slot.style.height = '';
        inline = false;
        syncBarFlag();
        return;
      }
      pay.classList.add('mw-atc-inline');
      slot.style.height = '0px';
      inFlowHeight = Math.max(0, Math.round(
        pay.getBoundingClientRect().bottom - slot.getBoundingClientRect().top
      ));
      apply(inline);
    }

    function update() {
      queued = false;
      if (!mq.matches) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var top = slot.getBoundingClientRect().top;
      var bottom = top + inFlowHeight;
      // Inline once the whole normal spot is in view; bar again as soon as it
      // slips below the fold or scrolls completely off the top.
      var next = inFlowHeight > 0 && bottom <= vh && bottom > 0 && !cookieBannerOpen();
      if (next === inline) return;
      apply(next);
      if (next) seenInline = true;
      else animateBarIn();
    }

    function queue() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }

    function remeasure() {
      measure();
      update();
    }

    remeasure();
    if (mq.matches && !inline) animateBarIn();
    window.addEventListener('scroll', queue, { passive: true });
    // Re-check after any tap (e.g. Accept/Decline on the cookie banner).
    document.addEventListener('click', function () { setTimeout(queue, 400); }, true);
    window.addEventListener('resize', function () { window.requestAnimationFrame(remeasure); });
    window.addEventListener('load', remeasure);
    if (mq.addEventListener) mq.addEventListener('change', remeasure);
    else if (mq.addListener) mq.addListener(remeasure);

    // Shop Pay renders late and the consent <small> gets moved in/out of the
    // buttons by the PDP script, both of which change the in-flow height.
    var pending;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(remeasure, 60);
    }).observe(pay, { childList: true, subtree: true });
  }

  function init() {
    var nodes = document.querySelectorAll('.product-single__form .payment-buttons');
    for (var i = 0; i < nodes.length; i++) setup(nodes[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
